import { useTranslation } from "react-i18next";
import { AssistantIdentity } from "./assistant-identity";

export function TypingIndicator() {
  const [translate] = useTranslation(["core"]);
  return (
    <div className="mr-auto flex max-w-[98%] flex-col items-start">
      <AssistantIdentity />
      <div
        className="agent-status-loading pl-10 font-body text-base font-medium leading-6"
        role="status"
        aria-live="polite"
        aria-atomic="true"
      >
        {translate("chatbot-typing")}
      </div>
    </div>
  );
}
